import Vue from 'vue'
import errorHandling from './exceptions'
import { SETTINGS } from '@/api'

// Retorna todas as configurações cadastradas
const all = (callback) => {
  Vue.axios.get(SETTINGS)
    .then(res => {
      callback(res.data.settings)
    })
    .catch(errorHandling)
}

// Retorna os dados de uma configuração
const find = (key, callback) => {
  Vue.axios.get(SETTINGS, { params: { key } })
    .then(res => {
      callback(res.data.settings)
    })
    .catch(errorHandling)
}

// Cria uma nova configuração
const store = (data, callback) => {
  Vue.axios.post(SETTINGS, data)
    .then(() => {
      callback()
    })
    .catch(errorHandling)
}

// Atualiza um grupo de configurações de uma vez
const updateAll = (data, callback) => {
  Vue.axios.put(SETTINGS, data)
    .then(() => {
      callback()
    })
    .catch(errorHandling)
}

// Atualiza os dados da configuração
const update = (key, data, callback) => {
  Vue.axios.put(SETTINGS + '/' + key, data)
    .then(() => {
      callback()
    })
    .catch(errorHandling)
}

// Remove a configuração
const destroy = (id, callback) => {
  Vue.axios.delete(SETTINGS + '/' + id)
    .then(() => {
      callback()
    })
    .catch(errorHandling)
}

export default {
  all,
  find,
  store,
  updateAll,
  update,
  destroy
}
